export default {
  update(el) {
    el.value = el.value.replace(/\s+/g, '');
  }
};
